export const LEGAL_META = {
  effective: "12 September 2026",
  email: "support@zeyinx.com",
  address: "Kakkazham East, Alappuzha, Kerala 688005, India",
  controller: "Enkrypt Enterprise, trading as Zeyinx",
};

export const GRIEVANCE = {
  officer: "Hari Prasath",
  designation: "Grievance Officer",
  email: "support@zeyinx.com",
  address: "Kakkazham East, Alappuzha, Kerala 688005, India",
};

export const LEGAL_DISCLAIMER =
  "These policies apply to Zeyinx, a trading brand of Enkrypt Enterprise. They should be reviewed by a qualified lawyer for the business’s operations, payment methods, data practices, and applicable jurisdictions before publication.";

export const TERMS = {
  slug: "terms",
  title: "Terms & Conditions",
  intro:
    "These Terms & Conditions (“Terms”) govern your access to and use of zeyinx.com and every purchase made through it. Zeyinx is a trading brand of Enkrypt Enterprise (“Zeyinx”, “we”, “us”), which operates zeyinx.com and sells digital gift-card codes.",
  grievance: true,
  sections: [
    {
      id: "acceptance",
      title: "Acceptance of Terms",
      paragraphs: [
        "By accessing or using the website, or by placing an order, you confirm that you have read, understood, and agree to be bound by these Terms. If you do not agree with any part of these Terms, please do not use the website or make a purchase.",
      ],
    },
    {
      id: "eligibility",
      title: "Eligibility",
      paragraphs: [
        "You must be legally capable of entering into a binding contract under the laws that apply to you. You agree to provide accurate, current, and complete information when placing an order, creating an account, or contacting us.",
      ],
    },
    {
      id: "digital-products",
      title: "Digital Products",
      paragraphs: [
        "All products sold by Zeyinx are digital gift-card codes delivered electronically by email. No physical cards, parcels, or shipments of any kind are sent.",
      ],
    },
    {
      id: "region-restrictions",
      title: "Product, Platform, and Region Restrictions",
      paragraphs: [
        "Each code is valid only for the platform, denomination, and country or region stated at the time of purchase. Redemption regions are enforced by the relevant platform, not by Zeyinx. You are responsible for verifying that your platform account’s redemption region matches the region of the code you are buying before you complete payment.",
      ],
    },
    {
      id: "market-availability",
      title: "Market Availability",
      paragraphs: [
        "Products on zeyinx.com are organised into markets such as India, Europe, Asia, North America, South America, Middle East & Africa, and Global. The market you select only filters what you browse — each product’s own catalog data determines where it can actually be redeemed.",
        "Every product page lists its region, country, currency, and exact redeemable countries. A product is never shown in a market unless its redeemable-country data supports it.",
      ],
    },
    {
      id: "third-party-brands",
      title: "Third-Party Brands",
      paragraphs: [
        "PlayStation, Xbox, Steam, Apple, Nintendo, and any other brands listed on the website are independent third parties. Their own redemption terms and platform rules apply to every code. Zeyinx is not affiliated with, endorsed by, or sponsored by these brands unless explicitly stated.",
      ],
    },
    {
      id: "orders-pricing-payments",
      title: "Orders, Pricing, and Payments",
      paragraphs: [
        "Prices, product availability, display currencies, and payment options may change at any time before payment confirmation. An order is accepted only after your payment has been verified.",
        "Where legally permitted, Zeyinx may correct obvious pricing, product, or availability errors, including after an order has been placed. Where an order cannot be fulfilled, a refund will be offered.",
      ],
    },
    {
      id: "delivery",
      title: "Delivery",
      paragraphs: [
        "Codes are delivered by email after payment verification. Most orders arrive within a few hours; please allow up to 24 hours. Delivery may be delayed by payment verification, fraud-prevention checks, security review, or technical processing.",
      ],
    },
    {
      id: "customer-responsibilities",
      title: "Customer Responsibilities",
      paragraphs: ["When ordering from Zeyinx, you are responsible for:"],
      bullets: [
        "Entering the correct delivery email address at checkout.",
        "Selecting the correct product, value, platform, and redemption region before payment.",
        "Keeping your codes secure after delivery.",
      ],
    },
    {
      id: "fraud",
      title: "Fraud and Suspicious Activity",
      paragraphs: [
        "Subject to applicable law, Zeyinx may delay, decline, cancel, refund, limit, or request verification for any order we reasonably suspect involves fraud, unauthorised payments, sanctions concerns, unlawful activity, or a breach of these Terms.",
      ],
    },
    {
      id: "intellectual-property",
      title: "Intellectual Property",
      paragraphs: [
        "All content on the website — including text, design, and artwork — belongs to Enkrypt Enterprise or its licensors. Third-party trademarks, brand names, and logos remain the property of their respective owners and appear on this website for identification purposes only.",
      ],
    },
    {
      id: "liability",
      title: "Limitation of Liability",
      paragraphs: [
        "Nothing in these Terms limits or excludes any right or liability that cannot legally be limited or excluded. Where legally permitted, Zeyinx’s total liability for any claim relating to an order is limited to the amount you paid for the affected order.",
      ],
    },
    {
      id: "changes",
      title: "Changes",
      paragraphs: [
        "Zeyinx may update these Terms at any time by publishing a revised version on the website. The version in force when you place an order applies to that order.",
      ],
    },
    {
      id: "governing-law",
      title: "Governing Law",
      paragraphs: [
        "These Terms are governed by the laws of India. Courts located in Kerala, India will have jurisdiction over disputes arising from these Terms where legally permitted. Nothing in these Terms limits mandatory consumer rights or legal remedies available under applicable law.",
      ],
    },
    {
      id: "grievance",
      title: "Grievance Redressal",
      paragraphs: [
        "If you have a complaint, concern, or grievance about our products or services, please contact our Grievance Officer:",
      ],
      grievanceBlock: true,
    },
  ],
};

export const REFUND = {
  slug: "refund",
  title: "Refund Policy",
  intro:
    "We want every Zeyinx order to go smoothly. Because our products are digital codes, a few special rules apply — this policy explains them in plain language.",
  grievance: true,
  sections: [
    {
      id: "digital-nature",
      title: "Digital Product Nature",
      paragraphs: [
        "Gift-card codes are digital products delivered electronically. Unlike physical goods, a delivered code cannot be returned in the usual sense, which is why the rules below apply.",
      ],
    },
    {
      id: "general-rule",
      title: "General Refund Rule",
      paragraphs: [
        "Once a code has been delivered, displayed, accessed, shared, or redeemed, it is generally not refundable, except where a refund is required by applicable law.",
      ],
    },
    {
      id: "eligible",
      title: "Eligible Refund Situations",
      paragraphs: ["Please contact support@zeyinx.com if any of the following applies to your order:"],
      bullets: [
        "You were charged more than once for the same order.",
        "A code was not delivered after the stated delivery period.",
        "A delivered code is defective, invalid, or does not match the purchased product — provided it has not been redeemed and you can supply reasonable evidence.",
        "A refund is otherwise required by applicable law.",
      ],
    },
    {
      id: "non-refundable",
      title: "Non-Refundable Situations",
      paragraphs: ["Unless required by law, refunds are not available for:"],
      bullets: [
        "Codes that have already been delivered, accessed, displayed, shared, or redeemed.",
        "Incorrect platform, country, region, account, denomination, or delivery-email selection made by the customer.",
        "Change of mind after digital delivery.",
        "A customer account that does not meet the third-party platform’s redemption requirements.",
        "Loss, theft, sharing, or unauthorised use of a code after delivery.",
      ],
    },
    {
      id: "requesting",
      title: "Requesting a Refund",
      paragraphs: [
        "To request a refund, email support@zeyinx.com with your order number, the email address used at checkout, a description of the issue, and any evidence we reasonably request. Please never send your full gift-card code by email — we will never ask you to.",
      ],
    },
    {
      id: "review",
      title: "Review and Payment",
      paragraphs: [
        "Every request is reviewed individually. If a refund is approved, it is made to the original payment method where possible, within a reasonable period and subject to your payment provider’s processing times.",
      ],
    },
    {
      id: "consumer-rights",
      title: "Consumer Rights",
      paragraphs: [
        "Nothing in this policy limits or removes mandatory consumer rights under Indian law or any applicable law in your location.",
      ],
    },
    {
      id: "grievance",
      title: "Grievance Redressal",
      paragraphs: [
        "If your concern is not resolved to your satisfaction, you can escalate it to our Grievance Officer:",
      ],
      grievanceBlock: true,
    },
  ],
};

export const PRIVACY = {
  slug: "privacy",
  title: "Privacy Policy",
  intro:
    "This Privacy Policy explains how Enkrypt Enterprise, trading as Zeyinx (“Zeyinx”, “we”, “us”), collects, uses, and protects personal data when you use zeyinx.com. We process personal data in accordance with applicable law, including India’s Digital Personal Data Protection Act, 2023, where applicable.",
  grievance: true,
  sections: [
    {
      id: "controller",
      title: "Data Controller",
      paragraphs: [
        "The data controller is Enkrypt Enterprise, trading as Zeyinx, Kakkazham East, Alappuzha, Kerala 688005, India.",
      ],
    },
    {
      id: "data-collected",
      title: "Data Collected",
      paragraphs: ["We collect and process the following categories of personal data:"],
      bullets: [
        "Delivery email address.",
        "Order details: product, denomination, redemption region, display currency, total, and order status.",
        "Payment reference data received from payment providers.",
        "Device, browser, IP, cookie, and website-usage data where used.",
        "Support emails and communications.",
      ],
      after:
        "Zeyinx does not store card numbers, CVVs, or customer crypto-wallet secrets. Payment card details are processed directly by our payment providers.",
    },
    {
      id: "why-used",
      title: "Why Data Is Used",
      paragraphs: ["We use personal data to:"],
      bullets: [
        "Process orders and deliver codes.",
        "Send transaction and delivery emails.",
        "Prevent fraud and unauthorised transactions.",
        "Provide customer support.",
        "Maintain legal, tax, accounting, and dispute records.",
        "Improve security and website performance.",
        "Send marketing only where permitted and with opt-out options.",
      ],
    },
    {
      id: "legal-grounds",
      title: "Legal Grounds",
      paragraphs: [
        "We process personal data to perform a contract (for example, to deliver your order), to meet legal obligations, to protect legitimate interests such as fraud prevention and security, and with your consent where required.",
      ],
    },
    {
      id: "sharing",
      title: "Sharing",
      paragraphs: ["We share personal data only where needed, with:"],
      bullets: [
        "Payment providers.",
        "Email delivery providers.",
        "Hosting and database providers.",
        "Fraud and security providers.",
        "Authorised fulfilment suppliers.",
        "Professional advisers.",
        "Regulators and authorities, where required by law.",
      ],
    },
    {
      id: "transfers",
      title: "International Transfers",
      paragraphs: [
        "Your data may be processed outside your country of residence. Where required, we apply appropriate safeguards to such transfers.",
      ],
    },
    {
      id: "retention",
      title: "Retention",
      paragraphs: [
        "We retain personal data only for as long as needed for order fulfilment, customer support, fraud prevention, legal obligations, accounting, and dispute handling, after which it is deleted or anonymised.",
      ],
    },
    {
      id: "security",
      title: "Security",
      paragraphs: [
        "We use reasonable technical and organisational safeguards to protect personal data. However, no online system can guarantee absolute security.",
      ],
    },
    {
      id: "your-rights",
      title: "Customer Rights",
      paragraphs: [
        "Depending on the law that applies to you, you may request access, correction, deletion, restriction, objection, portability, or withdrawal of consent. To exercise any of these rights, email support@zeyinx.com.",
      ],
    },
    {
      id: "contact",
      title: "Contact",
      paragraphs: [
        "Privacy requests: support@zeyinx.com.",
        "Business address: Kakkazham East, Alappuzha, Kerala 688005, India.",
      ],
    },
    {
      id: "grievance",
      title: "Grievance Redressal",
      paragraphs: [
        "For unresolved privacy concerns, you may contact our Grievance Officer:",
      ],
      grievanceBlock: true,
    },
  ],
};

export const AML = {
  slug: "aml",
  title: "AML & Financial Crime Policy",
  intro:
    "Zeyinx is committed to preventing its services from being misused for financial crime. This policy describes the measures and expectations that apply to orders placed on zeyinx.com.",
  grievance: false,
  sections: [
    {
      id: "purpose",
      title: "Purpose",
      paragraphs: [
        "This policy aims to prevent fraud, money laundering, terrorist financing, sanctions evasion, stolen-payment activity, and other unlawful use of the website.",
      ],
    },
    {
      id: "customer-obligations",
      title: "Customer Obligations",
      paragraphs: [
        "Customers must provide accurate information, use payment methods they are authorised to use, and use purchased products lawfully.",
      ],
    },
    {
      id: "monitoring",
      title: "Transaction Monitoring",
      paragraphs: [
        "Zeyinx may review orders for unusual patterns, repeated failed payments, chargebacks, mismatches between payment and location data, high-value activity, suspected fraud, and other relevant risk indicators.",
      ],
    },
    {
      id: "verification",
      title: "Verification",
      paragraphs: [
        "Where permitted and appropriate, Zeyinx may request reasonable additional information before processing, fulfilling, cancelling, or refunding an order.",
      ],
    },
    {
      id: "refusal",
      title: "Refusal, Delay, Cancellation, and Refund",
      paragraphs: [
        "Subject to applicable law, Zeyinx may delay, decline, cancel, limit, or refund an order where there is a reasonable concern about fraud, unlawful activity, sanctions, payment risk, or a breach of our policies.",
      ],
    },
    {
      id: "cooperation",
      title: "Cooperation",
      paragraphs: [
        "Zeyinx may retain records and cooperate with payment providers, regulators, law enforcement, and other competent authorities where legally required.",
      ],
    },
    {
      id: "prohibited",
      title: "Prohibited Activity",
      paragraphs: [
        "Customers must not use the website to conceal their identity, evade sanctions, use stolen payment instruments, or facilitate any unlawful conduct.",
      ],
    },
    {
      id: "contact",
      title: "Contact",
      paragraphs: ["Questions about this policy: support@zeyinx.com."],
    },
  ],
};

export const DELIVERY = {
  slug: "delivery",
  title: "Delivery Policy",
  intro:
    "This Delivery Policy explains how digital gift-card codes purchased on zeyinx.com are delivered, and what to do if something goes wrong.",
  grievance: true,
  sections: [
    {
      id: "digital-only",
      title: "Digital Delivery Only",
      paragraphs: [
        "Zeyinx sells digital gift-card codes only. No physical cards or parcels are shipped.",
      ],
    },
    {
      id: "method",
      title: "Delivery Method",
      paragraphs: [
        "After successful payment confirmation, the purchased gift-card code is sent to the delivery email address entered at checkout. Please make sure this email address is accurate before you pay.",
      ],
    },
    {
      id: "time",
      title: "Delivery Time",
      paragraphs: [
        "Orders are verified and fulfilled manually after payment. Most codes are delivered within a few hours of payment confirmation. In some cases — for example additional payment verification or fraud-prevention checks — delivery may take up to 24 hours.",
      ],
    },
    {
      id: "confirmation",
      title: "Order Confirmation",
      paragraphs: [
        "After payment, you receive an order-confirmation email. After fulfilment, you receive a delivery email containing the relevant digital gift-card code and redemption information.",
      ],
    },
    {
      id: "delayed",
      title: "Delayed Delivery",
      paragraphs: [
        "If your code has not arrived within 24 hours of payment, please check your spam and junk folders first, then email support@zeyinx.com with your order number and delivery email address.",
      ],
    },
    {
      id: "security",
      title: "Security and Verification",
      paragraphs: [
        "Zeyinx may delay delivery or request additional verification when an order appears unusual, fraudulent, unauthorised, or high-risk.",
      ],
    },
    {
      id: "completion",
      title: "Delivery Completion",
      paragraphs: [
        "Delivery is considered complete when the code is sent to the email address submitted at checkout. You are responsible for securing your email account and your code after delivery.",
      ],
    },
    {
      id: "redemption",
      title: "Redemption Responsibility",
      paragraphs: [
        "Please confirm the product platform and redemption region before payment. Zeyinx is not responsible for non-redemption caused by an incorrect platform, country, region, account, denomination, or delivery email selected by the customer.",
      ],
    },
    {
      id: "support",
      title: "Support",
      paragraphs: ["Delivery questions: support@zeyinx.com."],
    },
    {
      id: "grievance",
      title: "Grievance Redressal",
      paragraphs: [
        "For unresolved delivery concerns, you may contact our Grievance Officer:",
      ],
      grievanceBlock: true,
    },
  ],
};
